<template>
<h1>Policy</h1>
</template>

<script>
export default {
  name: "Policy"
}
</script>